<template>
  <div>
    <div class="card-body px-0">
      <b-row>
        <b-col xl="6">
          <b-form-group id="input-group-1" label="Roles:" label-for="input-1">
            <multiselect v-model="form.roles" :options="roles" :multiple="true" :taggable="true" label="text" track-by="value"
              select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
              placeholder="Roles que pueden visualizar el post">
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="input-group-1" label="Etiquetas:" label-for="input-1">
            <multiselect v-model="form.tags" :options="tags" :multiple="true" :taggable="true" label="text" track-by="value"
            tag-placeholder="Presiona enter para crear etiquetas" select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
              placeholder="Seleccione una opción" @tag="addTag">
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-2" label="Título:" label-for="input-2">
            <b-form-input id="input-2" v-model="form.title" required placeholder="Ingrese el título de la publicación"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-3" label="Contenido:">
            <div class="mb-3">
              <VueEditor v-model="form.content" :editor-toolbar="customToolbar2" />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" class="pr-0">
          <!-- <img :src="form.pathImage"  width="175" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/> -->
          <b-form-file
            @change="onFileChange"
            placeholder="Seleccione una imagen"
            drop-placeholder="Suelta la imagen aquí"
            accept="image/jpeg, image/png, image/gif"
            browse-text="Buscar imagen"
            v-model="form.file"
          ></b-form-file>
        </b-col>
        <b-col xl="1" align-self="center" class="pl-2">
          <i :class=" form.file !== null ? 'fa fa-check text-green' : 'fa fa-question text-warning'" />
        </b-col>
        <b-col offset-xl="3">
          <!-- <b-button @click="save()" variant="primary" class="mr-2 mb-3 mt-3">{{ isEditingUser ? 'Guardar cambios' : 'Crear'}}</b-button> -->
          <b-button @click="cleanAndBack()" variant="secondary" size="sm" class="mr-1 ">
            Cancelar e ir a lista
          </b-button>
          <b-button @click="save()" variant="primary">{{ isEditing.value ? 'Guardar cambios' : 'Crear'}}</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/services/axios'
import Swal from 'sweetalert2'
import { VueEditor } from 'vue2-editor'
import apiClient from '@/services/axios'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
    VueEditor,
  },
  name: 'cmsCreate',
  props: {
    isEditing: {
      type: Object,
    },
  },
  data() {
    return {
      customToolbar2: [[{
        header: [false, 1, 2, 3, 4, 5, 6],
      }], ['bold', 'italic', 'underline', 'strike'],
      [{
        align: '',
      }, {
        align: 'center',
      }, {
        align: 'right',
      }, {
        align: 'justify',
      }], ['blockquote'], [{
        list: 'ordered',
      }, {
        list: 'bullet',
      }, {
        list: 'check',
      }], [{
        indent: '-1',
      }, {
        indent: '+1',
      }], // outdent/indent
      [{
        color: [],
      }, {
        background: [],
      }], ['clean'], // remove formatting button
      ],
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
      roles: [],
      form: {
        roles: [],
        tags: [],
        title: '',
        content: '',
        file: null,
        fileUrl: '',
      },
      categories: [],
      tags: [],
    }
  },
  created: function () {
  },
  mounted: function () {
    this.setData()
    if (this.isEditing.value) {
      apiClient.get(`/cms/${this.isEditing.id}`).then(response => {
        this.form = {
          title: response.data.title,
          tags: response.data.categories.map(x => {
            return {
              value: x.id,
              text: x.name,
            }
          }),
          content: response.data.description,
          roles: this.roles.filter(role => response.data.availableRoles.includes(role.value)),
          file: null,
          fileUrl: response.data.pathBanner,
        }
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    }
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  watch: {
  },
  methods: {
    setData() {
      apiClient.get('/roles').then(response => {
        this.roles = response.data.results.map(x => {
          return {
            value: x.id,
            text: x.name,
          }
        })
        this.roles = this.roles.filter(x => {
          if (x.value > 5) {
            return x
          }
        })
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(err),
        })
      })
      apiClient.get('/products/categories?type=2').then(response => {
        if (response.data.length > 0) {
          this.tags = response.data.map(x => {
            return {
              value: x.id,
              text: x.name,
            }
          })
        }
      })
    },
    addTag (newTag) {
      const tag = {
        text: newTag,
        value: null,
      }
      this.form.tags.push(tag)
      this.tags.push(tag)
    },
    onFileChange(e) {
      if (e.target.files[0].size > 5000000) {
        this.form.file = null
        return Toast.fire({
          icon: 'warning',
          title: 'La imagen tiene ' + ((e.target.files[0].size / 1000000)).toFixed() + 'MB y no puede superar las 5MB',
        })
      } else {
        this.form.fileUrl = URL.createObjectURL(e.target.files[0])
      }
    },
    save() {
      if (this.form.title.length < 1) {
        return Toast.fire({
          icon: 'warning',
          title: 'El título no debe estar vacío',
        })
      }
      if (this.form.content.length < 1 && this.form.fileUrl.length < 1) {
        return Toast.fire({
          icon: 'warning',
          title: 'El post debe contener imagen y/o contenido',
        })
      }
      const formData = new FormData()
      if (this.form.file !== null) {
        formData.append('file', this.form.file)
      }
      formData.append('form', JSON.stringify(this.form))
      if (!this.isEditing.value) {
        apiClient.post('/cms', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Post creado con éxito',
          })
          this.$emit('finished')
        }).catch(err => {
          console.log(err.response.data)
          Toast.fire({
            icon: 'danger',
            title: 'Error al guardar la información',
          })
        })
      } else {
        apiClient.patch('/cms/' + this.isEditing.id, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          Toast.fire({
            icon: 'success',
            title: 'Post actualizado con éxito',
          })
          this.$emit('finished')
        }).catch(err => {
          console.log(err.response.data)
          Toast.fire({
            icon: 'danger',
            title: 'Error al guardar la información',
          })
        })
      }
    },
    cleanAndBack() {
      this.$emit('finished')
    },
  },
}
</script>
